import { createAction, createApiAction } from '@saucelabs/sl-util-redux';
import { api as tunnelsApi } from '@saucelabs/sl-module-tunnels';

import * as api from './api';
import * as types from './types';
import { api as usersApi } from './../users';
import { api as activityApi } from './../activity';

export const initialized = createAction(types.INITIALIZED);
export const cleanup = createAction(types.CLEANUP);

export const getUser = createApiAction(
  types.USER_GET,
  (payload) => api.getUser(payload),
);

export const getAccessKey = createApiAction(
  types.USER_GET_ACCESS_KEY,
  (payload) => api.getAccessKey(payload),
);

export const resetPassword = createApiAction(
  types.USER_RESET_PASSWORD,
  (payload) => api.sendResetPasswordEmail(payload),
);

export const removeTeamMembership = createApiAction(
  types.REMOVE_TEAM_MEMBERSHIP,
  (payload) => usersApi.removeMembership(payload),
);

export const addTeamMembership = createApiAction(
  types.ADD_TEAM_MEMBERSHIP,
  (payload) => usersApi.postMembership(payload),
);

export const getUserActivity = createApiAction(
  types.ACTIVITY_GET,
  (payload) => activityApi.getUserActivity(payload),
);

export const deactivateUser = createApiAction(
  types.USER_DEACTIVATE,
  (payload) => usersApi.deactivateUser(payload),
);

export const reactivateUser = createApiAction(
  types.USER_REACTIVATE,
  (payload) => usersApi.reactivateUser(payload),
);

export const resetAccessKey = createApiAction(
  types.RESET_ACCESS_KEY,
  (payload) => usersApi.postResetAccessKey(payload),
);

export const getUserTunnels = createApiAction(
  types.TUNNELS_GET,
  (payload) => tunnelsApi.getOrganizationTunnels(payload),
);

export const stopTunnel = createApiAction(
  types.STOP_TUNNEL,
  (payload) => tunnelsApi.stopTunnel(payload),
);

export const changeEmail = createApiAction(
  types.CHANGE_EMAIL,
  (payload) => api.changeEmail(payload),
);

export const changePassword = createApiAction(
  types.CHANGE_PASSWORD,
  (payload) => api.changePassword(payload),
);

export const changeAssignedTeams = createApiAction(
  types.CHANGE_ASSIGNED_TEAMS,
  (payload) => api.changeAssignedTeams(payload),
);
